import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AiFillPlayCircle } from "react-icons/ai";

import "./styles.scss";
import {
  useWorkShop,
  WorkshopSectionContent,
  WorkshopSectionContentType,
} from "../../../../contexts/workshop-context/WorkshopContext";

import { MediaURLContent } from "../../../dashboard/containers/update-workshops/components/media-card/url/MediaURL";
import getIconByType from "../../../../shared/resources/file-types/file-types";
import { MediaFileContent } from "../../../dashboard/containers/update-workshops/components/media-card/MediaCard";
// @ts-ignore
import renderHTML from "react-render-html";

const SubSection = () => {
  const workshop = useWorkShop();

  const getURLContent = (content: string): MediaURLContent => {
    try {
      const data = JSON.parse(content);
      if (data) {
        return data;
      } else {
        return { text: content, url: content };
      }
    } catch (e) {
      return { text: content, url: content };
    }
  };

  const getFileContent = (content: string): MediaFileContent => {
    try {
      const data: MediaFileContent = JSON.parse(content);
      if (data) {
        return data;
      } else {
        return { fileName: data, url: data, type: "all" };
      }
    } catch (e) {
      return { fileName: content, url: content, type: "all" };
    }
  };

  const getResourcePreview = (resource: WorkshopSectionContent) => {
    switch (resource.type) {
      case WorkshopSectionContentType.URL:
        return (
          <div style={{ fontSize: "24px", marginBottom: "16px" }}>
            <a
              href={getURLContent(resource.content).url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {getURLContent(resource.content).text}
            </a>
          </div>
        );
      case WorkshopSectionContentType.TEXT:
        return (
          <p
            className="text-justify"
            style={{ color: "#646464", fontSize: "24px", marginBottom: "16px" }}
          >
            {renderHTML(resource.content)}
          </p>
        );
      case WorkshopSectionContentType.IMAGE_URL:
        return (
          <div className="text-center" style={{ marginBottom: "16px" }}>
            <img
              src={getFileContent(resource.content).url}
              key={getFileContent(resource.content).url}
              style={{ width: "40%" }}
              alt=""
            />
          </div>
        );
      case WorkshopSectionContentType.FILE_URL:
        return (
          <div
            className="text-left"
            style={{
              marginBottom: "16px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={getIconByType(getFileContent(resource.content).type)}
              alt=""
              key={getIconByType(getFileContent(resource.content).type)}
              style={{ width: "30px" }}
            />
            <a
              style={{ fontSize: "24px", marginLeft: "10px" }}
              href={getFileContent(resource.content).url}
              rel="noopener noreferrer"
              target="_blank"
            >
              {getFileContent(resource.content).fileName}
            </a>
          </div>
        );
      default:
        return (
          <video
            style={{ width: "100%", cursor: "default", marginBottom: "16px" }}
            controls
            controlsList="nodownload"
            key={getFileContent(resource.content).url}
            onContextMenu={(e) => e.preventDefault()}
          >
            <source src={getFileContent(resource.content).url} />
          </video>
        );
    }
  };

  return (
    <Container fluid className="st-subsection-preview">
      <Row>
        <Col xs={12} className="mb-4">
          <label className="font-weight-bold subsection-summery-title">
            {workshop.selectedSubSection.subSectionTitle}
          </label>
        </Col>
      </Row>
      {workshop.selectedSubSection.workshopSectionContent.map((res) => (
        <Row key={res.orderNo} className="p-0">
          <Col xs={12}>{getResourcePreview(res)}</Col>
        </Row>
      ))}

      <Row>
        <Col xs={12} className="d-flex justify-content-between">
          {workshop.selectedSubSection.orderNo !== 0 ? (
            <button
              className="stsub-action-button"
              onClick={() => {
                workshop.setSelectedSubSection(
                  workshop.workshopSections.filter(
                    (s) => s.orderNo === workshop.selectedSubSection.orderNo - 1
                  )[0]
                );
              }}
            >
              <AiFillPlayCircle
                style={{ marginRight: "15px", transform: "rotateY(180deg)" }}
              />
              Previous
            </button>
          ) : (
            <div></div>
          )}
          {workshop.selectedSubSection.orderNo !==
          workshop.workshopSections.length - 1 ? (
            <button
              className="stsub-action-button"
              onClick={() => {
                workshop.setSelectedSubSection(
                  workshop.workshopSections.filter(
                    (s) => s.orderNo === workshop.selectedSubSection.orderNo + 1
                  )[0]
                );
              }}
            >
              Next
              <AiFillPlayCircle style={{ marginLeft: "15px" }} />
            </button>
          ) : (
            <div></div>
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default SubSection;
